import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
    duration: 750,
    easing: 'ease',
    offset: -100, // Height of navbar +5
});
